export const ExpressionOperators = {
  EQUAL_TO: { operator: '==', label: 'is equal to' },
  NOT_EQUAL_TO: { operator: '!=', label: 'is not equal to' },
  GREATER_THAN: { operator: '>', label: 'is more than' },
  LESS_THAN: { operator: '<', label: 'is less than' },
  GREATER_THAN_OR_EQUAL_TO: { operator: '>=', label: 'is more than or equal to' },
  LESS_THAN_OR_EQUAL_TO: { operator: '<=', label: 'is less than or equal to' },
};
